import { GridColDef } from '@mui/x-data-grid';

export const getLogisticsOrderDetailsAdditionalChargesColumns = (): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Charge',
  },
  {
    field: 'quantity',
    headerName: 'Qty',
  },
  {
    field: 'price',
    headerName: 'Price',
  },
  {
    field: 'total',
    headerName: 'Total',
  },
];
